import { fork, put, take, takeEvery } from 'redux-saga/effects';

import { toDaiCostsApiSearchParams } from '../domain/daiCosts/types';

import {
  DataSettingsDaiCostsActionCreators,
  DataSettingsDaiCostsActionTypes,
  dataSettingsDaiCostsDataSelector,
  dataSettingsDaiCostsFetchLoadingStateSelector,
} from '../redux/server/dataSettingsDaiCosts';
import {
  DaiCostsSettingActionCreators,
  DaiCostsSettingActionTypes,
  SearchSettingDaiCostsAction,
} from '../redux/ui/daiCostsSetting';
import { customSelect } from '../utils/customSelect';

/**
 * 初回データ取得
 */
function* initFetchDaiCostsDataSaga() {
  const loadingState = yield* customSelect(
    dataSettingsDaiCostsFetchLoadingStateSelector
  );

  if (loadingState !== 'prepare') {
    return;
  }

  yield put(
    DataSettingsDaiCostsActionCreators.fetchDataSettingsDaiCostsAction()
  );

  // NOTE: 初回レスポンスで返されるendDateは、選択可能な最大未来日となるため
  // 以降のリクエストで上書きされないように個別にreduxへ保存する
  yield take(
    DataSettingsDaiCostsActionTypes.FETCH_DATA_SETTINGS_DAI_COSTS_SUCCESS
  );
  const daiCostsData = yield* customSelect(dataSettingsDaiCostsDataSelector);

  if (daiCostsData?.setting.endDate == null) return;

  yield put(
    DaiCostsSettingActionCreators.saveDaiCostsSettingEndDateAction(
      daiCostsData.setting.endDate
    )
  );

  // ソートラベルの状態などフロントでソートしている関係上UI側の設定を見ているのでUIの情報を更新
  yield put(
    DaiCostsSettingActionCreators.selectDaiCostsSettingFormCondition({
      startDate: daiCostsData.setting.startDate,
      endDate: daiCostsData.setting.endDate,
      sort: daiCostsData.setting.sort,
      order: daiCostsData.setting.order,
    })
  );
}

/**
 * 変更後の検索フォームでデータを取得する
 */
function* searchDataSettingsDaiCostsSaga(action: SearchSettingDaiCostsAction) {
  yield put(
    DataSettingsDaiCostsActionCreators.fetchDataSettingsDaiCostsAction(
      toDaiCostsApiSearchParams(action.payload.searchParams)
    )
  );
}

/**
 * 初回表示時のデータ取得
 */
function* handleInitFetchSaga() {
  yield takeEvery(
    DaiCostsSettingActionTypes.INIT_DAI_COSTS_SETTING,
    initFetchDaiCostsDataSaga
  );
}

/**
 * 検索時のデータ取得
 */
function* handleSearchFetchSaga() {
  yield takeEvery(
    DaiCostsSettingActionTypes.SEARCH_DAI_COSTS_SETTING,
    searchDataSettingsDaiCostsSaga
  );
}

export function* daiCostsSettingSaga() {
  yield fork(handleInitFetchSaga);
  yield fork(handleSearchFetchSaga);
}
